<template>
  <div>
    <v-row>
      <v-col cols="12">
        <TinyEditor
          :api-key="tinymceKey"
          :init="tinymceSettings"
          v-model="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-btn class="float-right" @click="save">Shrani</v-btn>
        <v-btn class="float-right mr-4" @click="$emit('reset')" v-if="canReset">Nastavi privzeto</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TinyEditor from '@tinymce/tinymce-vue'

export default {
  components: {
    TinyEditor
  },
  props: {
    value: {
      required: true,
      type: String
    },
    canReset: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      text: '',
      tinymceKey: 'cbxok3pir3e6ip7f1v8eld1o57nduokar0hgzfojkoioifal',
      tinymceSettings: {
        height: 250,
        menubar: false,
        plugins: ['paste code'],
        toolbar: 'undo redo | formatselect | bold | alignleft aligncenter alignright',
        block_formats: 'Navadno besedilo=p;Veliko besedilo=h3;Zelo veliko besedilo=h2',
        content_style: 'p { margin: 0px; } h2 { margin: 0px; } h3 { margin: 0px; }'
      }
    }
  },
  methods: {
    save () {
      this.$emit('input', this.text)
      this.$emit('save')
    }
  },
  created () {
    this.text = this.value
  },
  watch: {
    value (value) {
      if (this.text !== value) {
        this.text = value
      }
    }
  }
}
</script>
